<template>
  <div class="error-jumbotron flex-1">
    <div class="flex items-center">
      <div class="flex-2 error-image">
        <img src="@/assets/image/404.png" alt />
      </div>
      <div class="flex-3 error-info">
        <h1>Sorry, you don't have permission to view the page.</h1>
        <p>
          Please ask you admin to assign you to be correct company to access our app. Please contact
          <a :href="'mailto:' + email" target="_blank">&lt;{{email}}&gt;</a> to get it resolved.
        </p>
        <p>
          <a href="javascript:void(0);" @click="$router.go(-1)">back</a>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import * as config from "@/config";
export default {
  data() {
    return {
      email: config.DEFAULT_CONTACT_EMAIL
    };
  },
  mounted: function() {
    this.$store.commit("closeSidebar");
  }
};
</script>